<div class="d-flex align-items-center">
  <div style="width:4em">
    <ng-select name="selectHeure"
      id="selectHeure"
      [(ngModel)]="heure"
      [clearable]="false"
      (change)="heureChangee()">
      @for (hour of tabHeures; track hour) {
        @if (hour % heureStep() == 0 && hour <= heureMaxi()) {
          <ng-option [value]="hour">{{hour}}</ng-option>
        }
      }
    </ng-select>
  </div>
  <div style="min-width:2em;text-align:center">h</div>
  <div style="width:4em">
    <ng-select name="selectMinute"
      id="selectMinute"
      [(ngModel)]="minute"
      [clearable]="false"
      (change)="minuteChangee()">
      @for (min of tabMinutesAffichees(); track min; let i = $index) {
        @if (i % minuteStep() == 0) {
          <ng-option [value]="tabMinutesValeurAffichees()[i]">{{min}}</ng-option>
        }
      }
    </ng-select>
  </div>
  <div style="min-width:2em;text-align:center">m</div>
</div>
